import type { ControlType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { useOptionalProducerProcessTemplateContext } from "~/areas/projects/components/Process/ProcessTemplates/ProducerProcessTemplateContext";
import { BaseParameterSelector } from "~/components/ParameterSelector/BaseParameterSelector";
interface ProcessTemplatesParameterSelectorProps {
    selectedParameter: string | null | undefined;
    onParameterChange(value: string | null): void;
    controlType: ControlType;
    allowClear: boolean;
    error?: string | undefined;
    label?: string;
    bindValue?: boolean;
}
export function ProcessTemplatesParameterSelector({ allowClear, controlType, error, label, onParameterChange, selectedParameter, bindValue = true }: ProcessTemplatesParameterSelectorProps) {
    const processTemplateContext = useOptionalProducerProcessTemplateContext();
    const parameters = processTemplateContext?.processTemplate.Parameters;
    return <BaseParameterSelector selectedParameter={selectedParameter} onParameterChange={onParameterChange} controlType={controlType} allowClear={allowClear} error={error} label={label} parameters={parameters} bindValue={bindValue}/>;
}
